/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { custom } from '@gh/core-data';
import { S3UploadItem, UploadStatus } from '@gh/core-ui';
import { omit } from 'lodash';

export const S3UploadItemMapper = custom({
  serialize: (item: S3UploadItem) => omit(item, ['uploadId', 'status', 'progress', 'file', 'blob']),
  deserialize: (item: any) => ({ ...item, status: UploadStatus.Completed }),
});
